{
  "instances": {
    "jolokia": {
      "label": "Java管理扩展",
      "close": "关闭",
      "domains": "域",
      "execute": "运行",
      "executing": "运行中...",
      "execution_failed": "运行失败。",
      "execution_successful": "运行成功。",
      "mbeans": "可管理资源"
    }
  }
}
